module.exports = __webpack_public_path__ + "img/nginx1.18995716.png";